import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { AvailableHeightBox } from '@fingo/lib/components/boxes';
import { useTheme } from '@mui/styles';
import LucilaNavbar from './LucilaNavbar';

const Layout = ({ children }) => {
  const theme = useTheme();
  useEffect(() => {
    document.body.style.backgroundColor = theme.palette.gray.A200;
  }, [theme]);

  return (
    <>
      <LucilaNavbar />
      <AvailableHeightBox>
        {children}
      </AvailableHeightBox>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.element.isRequired,
};

export default Layout;
